import {useCallback} from 'react';
import dayjs, {Dayjs} from 'dayjs';
import {ListItem} from '@mui/material';
import {DatePicker} from '@mui/x-date-pickers';
import CustomCalIcon from '../../../../../asset/icons/icon_calendar_gray.svg';
import {useSelector} from 'react-redux';
import {isInternalSelector} from '../../../../../store/Slices/userSlice';

export interface iTimedMsgDateRange {
  id: number;
  start_date: dayjs.Dayjs | null;
  end_date: dayjs.Dayjs | null;
}

type PickerProps = {
  name: string;
  value: Dayjs | null;
  minDate: Dayjs | null;
  onChange: (val: Dayjs, name: string) => void;
  label: string;
  disabled?: boolean;
};

const TimedMsgDatePicker = ({
  name,
  label,
  value,
  minDate,
  onChange,
  disabled,
}: PickerProps) => {
  const handleChange = useCallback(
    (val: dayjs.Dayjs | null) => {
      if (val) onChange(val, name);
    },
    [name, onChange],
  );

  function MuiIcon() {
    return (
      <img src={CustomCalIcon} alt='Date picker opening icon' width={23} />
    );
  }

  return (
    <DatePicker
      disablePast
      minDate={minDate ? minDate : undefined}
      label={label}
      value={value}
      slots={{openPickerIcon: MuiIcon}}
      onChange={handleChange}
      disabled={disabled}
      slotProps={{
        textField: {size: 'small'},
        calendarHeader: {className: 'month-year'},
      }}
    />
  );
};

type Props = {
  dateRange: iTimedMsgDateRange;
  onChange: (dateRange: iTimedMsgDateRange) => void;
  dayType: string;
};

const TimedMsgRequestDateRangePicker = ({
  dateRange,
  onChange,
  dayType,
}: Props) => {
  const isStaff = useSelector(isInternalSelector);
  const datePickerLable = dayType === 'no-end' ? 'Start Date' : 'Selecte Date';
  const handleChange = useCallback(
    (value: dayjs.Dayjs, name: string) => {
      const newDateRange = {...dateRange, [name]: value};
      if (
        newDateRange.start_date &&
        newDateRange.end_date &&
        newDateRange.start_date > newDateRange.end_date
      ) {
        newDateRange.end_date = newDateRange.start_date;
      }
      onChange(newDateRange);
    },
    [dateRange, onChange],
  );

  const minDate = isStaff ? dayjs() : dayjs().add(1, 'day');

  return (
    <ListItem disableGutters className='w-175'>
      <TimedMsgDatePicker
        name='start_date'
        label={datePickerLable}
        value={dateRange.start_date}
        onChange={handleChange}
        minDate={minDate}
      />
    </ListItem>
  );
};

export default TimedMsgRequestDateRangePicker;
